export const applicationGetters = {};
